import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import {
  cancelOwnAppointment,
  requestOwnAppointmentReschedule,
} from '@/api/appointments/appointmentsApi';
import type { OwnerAppointment } from '@/api/appointments/appointmentsApi.types';
import {
  OWN_PORTAL_SUMMARY_QUERY_KEY,
  OWN_UPCOMING_APPOINTMENTS_QUERY_KEY,
} from '@/constants/queryKeys';

export function useCancelOwnAppointmentMutation(): UseMutationResult<
  OwnerAppointment,
  Error,
  string
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelOwnAppointment,
    onSuccess: function invalidate() {
      queryClient.invalidateQueries({ queryKey: OWN_UPCOMING_APPOINTMENTS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: OWN_PORTAL_SUMMARY_QUERY_KEY });
    },
  });
}

interface RescheduleRequestVariables {
  appointmentId: string;
  message: string;
}

export function useRequestOwnAppointmentRescheduleMutation(): UseMutationResult<
  OwnerAppointment,
  Error,
  RescheduleRequestVariables
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: function request(variables: RescheduleRequestVariables) {
      return requestOwnAppointmentReschedule(variables.appointmentId, variables.message);
    },
    onSuccess: function invalidate() {
      queryClient.invalidateQueries({ queryKey: OWN_UPCOMING_APPOINTMENTS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: OWN_PORTAL_SUMMARY_QUERY_KEY });
    },
  });
}
